import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class ProductsService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("list-products");
  }
}



// WEBPACK FOOTER //
// ./src/app/products/products.service.ts